import React  from 'react';

const OnewayIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" className="oneway" width="34" height="34" viewBox="0 0 34 34">
  <g id="Group_552" transform="translate(6027.81 -917.5)">
    <g id="Group_524" transform="translate(93 -147.1)">
      <rect width="34" height="34" transform="translate(-6120.81 1064.6)" fill="#fff"/>
    </g>
    <path d="M-5991.782,1130.371h1.623l1.575,2.977h5.607l-2.895-8.358h2.165l5.88,8.223h3.4s2.768.631,2.757,1.384-2.513,1.5-2.757,1.5h-3.317l-5.928,8.173h-2.2l2.9-8.315h-5.607l-1.575,2.968h-1.623l1.3-4.294Z" transform="translate(-27.81 -199.406)" fill="#007bc2" />
  </g>
</svg>

}

export default OnewayIcon;
